package top.wcpe.allincore.ui.runtime.canvas

import top.wcpe.allincore.ui.runtime.ir.DslRuntimeError
import kotlin.jvm.JvmName

/**
 * canvas draw 字节码解释执行期错误。
 *
 * 访问器保留 `canvasId()` / `opcode()` / `byteOffset()` 的 Java 方法 ABI，
 * 同时 Kotlin 侧可用属性式访问。
 */
class CanvasExecutionException(
    /** canvas 元素 id；可能为 null（解释器被独立调用）。 */
    @get:JvmName("canvasId")
    val canvasId: String?,
    /** 出错的 draw opcode；-1 表示无关 opcode（如 count 头损坏）。 */
    @get:JvmName("opcode")
    val opcode: Int,
    /** ByteBuffer 抛错时的字节偏移；-1 表示未知。 */
    @get:JvmName("byteOffset")
    val byteOffset: Int,
    message: String,
    cause: Throwable?,
) : DslRuntimeError(message, cause = cause) {

    constructor(
        canvasId: String?,
        opcode: Int,
        byteOffset: Int,
        message: String,
    ) : this(canvasId, opcode, byteOffset, buildCanvasMessage(canvasId, opcode, byteOffset, message), null)
}

/** 字节掩码：opcode 以单字节无符号形式打印。 */
private const val BYTE_MASK = 0xFF

/** 构造携带 canvas 上下文的 message：id / opcode（十六进制）/ offset，缺失项自动省略。 */
private fun buildCanvasMessage(canvasId: String?, opcode: Int, byteOffset: Int, message: String): String {
    val sb = StringBuilder()
    sb.append("canvas[id=").append(canvasId ?: "?")
    if (opcode >= 0) {
        sb.append(", opcode=0x").append((opcode and BYTE_MASK).toString(radix = 16))
    }
    if (byteOffset >= 0) {
        sb.append(", offset=").append(byteOffset)
    }
    sb.append("] ").append(message)
    return sb.toString()
}
